import { render, staticRenderFns } from "./theModalConfirmacion.vue?vue&type=template&id=a0c56aae&scoped=true&"
import script from "./theModalConfirmacion.vue?vue&type=script&lang=js&"
export * from "./theModalConfirmacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c56aae",
  null
  
)

export default component.exports